import React from 'react'
import Title from '../../../../components/typography/title.component'
import Button from '../../../../components/buttons/buttons.component'
import styled from 'styled-components'
import Container from '../../../../components/layout/container.component'
import ModalConfirmation from '../../../../components/modal/modal-confirmation.component'
import UserFormComponent from './components/user-form.component'
import AccordionSecondary from './../../../../components/accordion/accordion-secondary.component'
import PasswordFormComponent from './components/password-form.component'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { AdminService } from '../../../../services/admin.service'
import { toastActions } from '../../../../actions/toast.actions'
import { setUserPermissions } from '../../../../helpers'
import { bindActionCreators } from 'redux'
import { Creators as SiteCreators } from '../../../../ducks/site/site'

const StyleSteps = styled.div`
	padding: 2.4rem 0;
`

const StyledButtonContainer = styled.div`
	padding-top: 2.7rem;
	display: grid;
	grid-gap: 15px;
	grid-template-columns: repeat(2, auto);
	justify-content: end;
`

const actions = {
	SAVE: 'SAVE',
	CANCEL: 'CANCEL'
}

class UserManagmentComponent extends React.Component {
	constructor(props) {
		super(props)
		const { match } = this.props
		this.id = match.params && match.params.id
		this.isEdit = this.id !== undefined
		this.action = null
		this.state = {
			loading: true,
			modalTitle: '',
			modalIsOpen: false,
			message: null
		}
		this.stepOneInitialValues = {
			name: '',
			email: '',
			emailConfirmation: ''
		}
		this.stepTwoInitialValues = {
			password: '',
			passwordConfirmation: '',
			securityKey: ''
		}
		this.data = Object.assign(
			this.isEdit
				? {
						identityUserId: this.id
				  }
				: {},
			{
				name: '',
				email: '',
				password: '',
				securityKey: ''
			}
		)
	}

	async componentWillMount() {
		const { history, showLoading, hideLoading, danger, user } = this.props
		if (this.isEdit) {
			showLoading()

			AdminService.get(this.id)
				.then(({ success, data, errors }) => {
					if (success) {
						this.stepOneInitialValues = {
							name: data.name,
							email: data.email,
							emailConfirmation: data.email
						}
						this.setState(
							{
								loading: false
							},
							() => {
								this.refs.accordion.openAll()
								hideLoading()
								setUserPermissions(user)
							}
						)
					} else {
						hideLoading()
						danger({ message: errors[0] })
						history.goBack()
					}
				})
				.catch(() => {
					danger({
						message:
							'Não foi possível buscar os dados do usuário para alteração, por favor tente novamente mais tarde'
					})
					hideLoading()
					history.goBack()
				})
		} else {
			this.setState(
				{
					loading: false
				},
				() => {
					setUserPermissions(user)
				}
			)
		}
	}

	componentDidMount() {
		this.refs.accordion && this.refs.accordion.openAll()
	}

	render() {
		const { loading, modalTitle, modalIsOpen, message } = this.state
		return loading ? null : (
			<Container small>
				<Title>
					{this.isEdit ? 'Alteração de dados do ' : 'Inclusão de '}
					usuário
				</Title>
				<StyleSteps>
					<AccordionSecondary
						ref="accordion"
						arrow={false}
						multiple={false}
						noClickable
						noAnimated
						items={getAccordionItems.call(this)}
					/>{' '}
					<StyledButtonContainer>
						<Button danger type="button" onClick={onCancel.bind(this)}>
							Cancelar
						</Button>
						<Button
							data-permission="43AB070CBD25C379551628477D99B21E5E8A92C8"
							primary
							type="button"
							onClick={onSave.bind(this)}>
							Salvar
						</Button>
					</StyledButtonContainer>
				</StyleSteps>
				<ModalConfirmation
					isOpen={modalIsOpen}
					title={modalTitle}
					onResult={onResult.bind(this)}>
					{typeof message === 'function' ? message() : message}
				</ModalConfirmation>
			</Container>
		)
	}
}

function getAccordionItems() {
	return [
		{
			title: 'Dados do Usuário',
			content: (
				<UserFormComponent
					ref="stepOne"
					initialValues={this.stepOneInitialValues}
					onSubmit={handleStepOneSubmit.bind(this)}
				/>
			)
		},
		{
			title: 'Senhas',
			content: (
				<PasswordFormComponent
					ref="stepTwo"
					initialValues={this.stepTwoInitialValues}
					isEdit={this.isEdit}
					onSubmit={handleStepTwoSubmit.bind(this)}
				/>
			)
		}
	]
}

function handleStepOneSubmit(values, { setFieldValue }) {
	const name = (values.name || '').trim().replace(/\s+/g, ' ')
	setFieldValue('name', name)
	this.data.name = name
	this.data.email = values.email
	this.refs.stepTwo.submit()
}

function handleStepTwoSubmit(values) {
	this.data.password = values.password
	this.data.securityKey = values.securityKey
	getSaveConfirmation.call(this)
}

async function onResult(confirmed) {
	const { history, showLoading, hideLoading, success, danger } = this.props
	this.setState({ modalIsOpen: false })
	if (confirmed) {
		switch (this.action) {
			case actions.SAVE:
				showLoading()
				if (this.isEdit) {
					AdminService.updateUser(this.data)
						.then(response => {
							hideLoading()
							if (response.success) {
								success({
									message: 'Cadastro do usuário atualizado com sucesso'
								})
								history.goBack()
							} else {
								danger({
									message: response.errors[0]
								})
							}
						})
						.catch(() => {
							hideLoading()
							danger({
								message:
									'Não foi possível atualizar o cadastro, por favor tente novamente mais tarde'
							})
							history.goBack()
						})
				} else {
					AdminService.createUser(this.data)
						.then(response => {
							hideLoading()
							if (response.success) {
								success({
									message: 'Cadastro do usuário realizado com sucesso'
								})
								history.goBack()
							} else {
								danger({
									message: response.errors[0]
								})
							}
						})
						.catch(() => {
							hideLoading()
							danger({
								message:
									'Não foi possível completar o cadastro, por favor tente novamente mais tarde'
							})
							history.goBack()
						})
				}
				break
			case actions.CANCEL:
				history.goBack()
				break
		}
	}
}

function onCancel(e) {
	e.preventDefault()
	this.action = actions.CANCEL
	const message = () => (
		<span>
			Você tem certeza que deseja cancelar a operação?
			<br />
			Todos os dados informados serão descartados
		</span>
	)

	this.setState({
		modalTitle: 'Cancelar',
		message,
		modalIsOpen: true
	})
}

function onSave(e) {
	e.preventDefault()
	this.refs.stepOne.submit()
}

function getSaveConfirmation() {
	this.action = actions.SAVE
	const message = this.isEdit
		? `Confirma a atualização dos dados do usuário?`
		: `Confirma a inclusão do usuário?`
	this.setState({
		modalTitle: 'Salvar',
		message,
		modalIsOpen: true
	})
}

const mapStateToProps = ({ user }) => ({
	user
})

const mapDispatchToProps = dispatch =>
	bindActionCreators({ ...SiteCreators, ...toastActions }, dispatch)

const connectedUserManagmentComponent = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(UserManagmentComponent)
)
export { connectedUserManagmentComponent as ModuleRootComponent }
